
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __exports as objectDefineProperties } from '../../../_virtual/object-define-properties.js';
export { __exports as default } from '../../../_virtual/object-define-properties.js';
import descriptors from './descriptors.js';
import v8PrototypeDefineBug from './v8-prototype-define-bug.js';
import './object-define-property.js';
import anObject$1 from './an-object.js';
import toIndexedObject$1 from './to-indexed-object.js';
import objectKeys$1 from './object-keys.js';
import { __exports as objectDefineProperty } from '../../../_virtual/object-define-property.js';

var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject = anObject$1;
var toIndexedObject = toIndexedObject$1;
var objectKeys = objectKeys$1;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};
//# sourceMappingURL=object-define-properties.js.map
